import { expand } from 'uri-template-lite';
import { apiClient } from '../../common/ApiClient';
import { createApiMutationHook } from '../../common/queryClient/createApiMutationHook';
import { SampleUrl } from './SampleUrl';

interface DeleteAllSamplesRequest {
  id: number;
  valueDate: string;
  type: string;
}

const deleteAllSamples = async ({
  id,
  valueDate,
  type,
}: DeleteAllSamplesRequest): Promise<void> =>
  apiClient
    .post(expand(SampleUrl.deleteAll, { id, valueDate, type }))
    .then(() => undefined);

export const useDeleteAllSamplesMutation = createApiMutationHook<
  DeleteAllSamplesRequest,
  void
>(['samples-delete-all'], deleteAllSamples);
